import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSendMessage = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 6.33333L7 1M7 1L13 6.33333M7 1L7 13",
		stroke: "currentColor",
		strokeLinecap: "round"
	})
});
export default SvgSendMessage;
